import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import FeatureContentComponent from './js/feature-content.component';

ComponentsFactory.getInstance().define('feature-content', FeatureContentComponent);
